import type { ReactNode } from "react"
import {
  CellType,
  type HorizontalProductBox,
} from "@gatsby-plugin-generic-page/fragments/horizontalProductBox"
import {
  type HorizontalTableCellsType,
  useHorizontalTableCells,
} from "./useHorizontalTableCells"

type PromoModalCells = {
  productBoxName?: string
  cellsWithoutPrice: HorizontalTableCellsType[]
  buttonHref?: string
  priceElement?: ReactNode
}

const usePromoModalCells = (
  productData?: HorizontalProductBox
): PromoModalCells => {
  const cells = useHorizontalTableCells(productData, true) || []

  const productBoxName = cells.find(
    (cell) => cell.type === CellType.NAME
  )?.textWithoutStyles
  const cellsWithoutPrice =
    cells.filter(
      (cell) => cell.type !== CellType.PRICE && cell.type !== CellType.NAME
    ) || []
  const buttonHref = cells[0]?.buttonHref
  const priceElement = cells.find((cell) => cell.type === CellType.PRICE)?.text

  return { productBoxName, cellsWithoutPrice, buttonHref, priceElement }
}

export default usePromoModalCells
